(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('AppAccountController', AppAccountController);

    AppAccountController.$inject = ['$scope', '$state', 'DataUtils', 'AppAccount'];

    function AppAccountController ($scope, $state, DataUtils, AppAccount) {
        var vm = this;
        
        vm.appAccounts = [];
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll() {
            AppAccount.query(function(result) {
                vm.appAccounts = result;
            });
        }
    }
})();
